// @flow

// - Stylesheet
import './inscription-step-course-item.less';

import Moment       from 'moment';
import formatAmount from 'utils/formatAmount';
import { View }     from '@insolus/backbone';

// - Models
import Course from 'models/course';

class InscriptionStepCourseItem extends View {
    model: Course;

    // eslint-disable-next-line global-require
    get template(): Function { return require('./inscription-step-course-item.hbs'); }

    // ——————————————————————————————————————————————————————
    // —
    // —     Rendering
    // —
    // ——————————————————————————————————————————————————————

    onRender() {
        this.$el.attr('data-id', this.model.get('id'));
        this.$el.addModifier('loaded');
    }

    serialize(): Object {
        return {
            'location'               : this.model.get('location'),
            'target-audience'        : this.model.get('targetAudience'),
            'level'                  : this.model.get('level'),
            'level-image'            : this.model.get('levelImage'),
            'level-description'      : this.model.get('levelDescription'),
            'price'                  : formatAmount(this.model.get('totalPrice')),
            'days-hours'             : this.model.getLessonsFormatted(),
            'total-lessons'          : this.model.get('totalLessons'),
            'start-year'             : Moment(this.model.get('period').startDate).year(),
            'end-year'               : Moment(this.model.get('period').endDate).year(),
            'start-month'            : this.model.get('period').startMonth,
            'end-month'              : this.model.get('period').endMonth,
            'day-of-start-date'      : Moment(this.model.get('period').startDate).date(),
            'day-of-end-date'        : Moment(this.model.get('period').endDate).date(),
            'max-number-of-students' : this.model.get('maxNumberOfStudents'),
            'number-of-inscriptions' : this.model.get('numberOfAssignedInscriptions'),
            'free-places'            : this.model.get('freePlaces')
        };
    }
}

export default InscriptionStepCourseItem;



// WEBPACK FOOTER //
// ./src/views/themes/front/components/inscription-step-course-item/inscription-step-course-item.js